import { render, staticRenderFns } from "./editPost.vue?vue&type=template&id=152ef73c&scoped=true&"
import script from "./editPost.vue?vue&type=script&lang=js&"
export * from "./editPost.vue?vue&type=script&lang=js&"
import style0 from "./editPost.vue?vue&type=style&index=0&id=152ef73c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ef73c",
  null
  
)

export default component.exports